import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewUiErrorPageComponent } from "../../shared/error-page/new-ui-error-page.component";
import { TranslateDirective } from "../../shared/transloco/translate.directive";

@Component({
  selector: "new-ui-login-denied",
  templateUrl: "./new-ui-login-denied.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NewUiErrorPageComponent],
})
export class NewUiLoginDeniedComponent {}
